/**
 * Checks if list article inline ads should be injected.
 * @param {string} currentType Type of the current body element
 * @param {string} nextType Type of the next body element.
 * @param {Number} currentTypeCurrentCount Number of current type elements injected prior to this one.
 * @param {Number} injectAfterCount Number after which the current element type should be injected.
 * @returns {Boolean}
 */
export default ({
  currentType,
  nextType,
  currentTypeCurrentCount,
  injectAfterCount,
}) => {
  if (injectAfterCount <= 0) return false;
  let result = false;

  // Inject ads according to rules
  if (
    (currentType === 'GalleryItem' && nextType === 'GalleryItem')
    && !(currentTypeCurrentCount % injectAfterCount) // every n shorthand
  ) result = true;

  // Inject ads after last GalleryItem if rule is met
  if (
    (currentType === 'GalleryItem' && nextType === null)
    && !(currentTypeCurrentCount % injectAfterCount) // every n shorthand
  ) result = true;

  return result;
};
